import React, { useState, useEffect } from 'react';
import { Box, CssBaseline, AppBar, Typography, Toolbar, Button } from '@mui/material';
import PlatformsBackground from './widgets/PlatformsBackground';
import { useNavigate } from "react-router-dom";
import smartClickLogo from '../images/smartclick-black-min.svg';

function Landing() {

    const navigate = useNavigate(); 

    useEffect(() => {
        // Navigate to /home there's a user in localStorage
        const storedUser = JSON.parse(localStorage.getItem('user'));
        if (storedUser) {
            navigate('/home', { state: { user: storedUser } });
        }
    }, [navigate]);

    const handleLoginNavigation = () => {
        navigate("/login"); // Replace with your desired route
    };

    const handleRegisterNavigation = () => {
        navigate("/register");
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column'}}>
            <CssBaseline />
            {/* App Bar */}
            <AppBar position="fixed">
                <Toolbar sx={{ backgroundColor: '#F8F9FA', height: 80, flexWrap: 'wrap'}}>
                    <Box
                        component="img"
                        src={smartClickLogo}
                        alt="SmartClick Logo" 
                        sx={{
                            height: 40,
                        }}
                    />
                    <Box sx={{ flexGrow: 1 }} />
                    <Button 
                        onClick={handleLoginNavigation}
                        variant="contained" 
                        sx={{ 
                            color: "white", 
                            backgroundColor: "#4680ff"
                        }}
                    >
                        Entrar
                    </Button>
                    <Button 
                        onClick={handleRegisterNavigation}
                        variant="contained" 
                        sx={{ 
                            color: "#4680ff", 
                            border: "0.5px solid #4680ff",
                            backgroundColor: "white",
                            marginLeft: 1,
                            display: { xs: 'none', md: 'block' }
                        }}
                    >
                        Cadastrar
                    </Button>
                </Toolbar>
            </AppBar>

            {/* Main Content */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    width: '100%',
                    zIndex: 1,
                    padding: 2,
                    textAlign: 'center'
                }}
                 >
                    <Typography variant="h3" textAlign="center">
                        Landing Page
                    </Typography>
                </Box>

            <PlatformsBackground/>
        </Box>
    );
}

export default Landing;